export enum ButtonType {
  button = 'button',
  submit = 'submit'
}
